export const getLocalizedMetaTitle = (
	category: {
		metaTitleDE?: string
		metaTitleAT?: string
		metaTitleCH?: string
		metaTitlePL?: string
	},
	locale: string,
) => {
	switch (locale) {
		case "de-DE":
			return category.metaTitleDE
		case "de-AT":
			return category.metaTitleAT
		case "de-CH":
			return category.metaTitleCH
		case "pl-PL":
			return category.metaTitlePL
		default:
			return null
	}
}

export const getLocalizedMetaDescription = (
	category: {
		metaDescriptionDE?: string
		metaDescriptionAT?: string
		metaDescriptionCH?: string
		metaDescriptionPL?: string
	},
	locale: string,
) => {
	switch (locale) {
		case "de-DE":
			return category.metaDescriptionDE
		case "de-AT":
			return category.metaDescriptionAT
		case "de-CH":
			return category.metaDescriptionCH
		case "pl-PL":
			return category.metaDescriptionPL
		default:
			return null
	}
}
